module.exports = __webpack_public_path__ + "assets/img/thumb-Superdraft-Social-Static-Ad-1.b218f411.webp";